import PropTypes from 'prop-types';

export function Table({
  children,
  ...props
}) {
  return (
    <table className="table" {...props}> 
        {children}
    </table> 
  )
}

Table.propTypes = {
  children: PropTypes.node
}


